module.exports = __webpack_public_path__ + "img/image19.02a66be5.png";